import { render, staticRenderFns } from "./soulinfo.vue?vue&type=template&id=16c39f68"
import script from "./soulinfo.vue?vue&type=script&lang=js"
export * from "./soulinfo.vue?vue&type=script&lang=js"
import style0 from "./soulinfo.vue?vue&type=style&index=0&id=16c39f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports